<template>
  <CFooter :fixed="false">
    <CLink class="privacy_link mr-5 " @click="privacyDialog = true">プライバシーポリシー</CLink>

    <div class="copywright">
      <a href="https://www.liberty-web.co.jp" target="_blank">Liberty</a>
      <span class="ml-1"
        >&copy; {{ new Date().getFullYear() }} System Produce</span
      >
    </div>
    <!-- div class="ml-auto">
      <span class="mr-1">Powered by</span>
      <a href="https://coreui.io/vue" target="_blank">CoreUI for Vue</a>
    </div -->
    <CModal
      color="info"
      :closeOnBackdrop="false"
      :centered="true"
      size="xl"
      :show.sync="privacyDialog"
    >
      <PrivacyPolicy />
      <template #header> プライバシーポリシー </template>
      <template #footer>
        <CButton @click="privacyDialog = false" color="danger"
          ><i class="icon cil-x"></i> 閉じる</CButton
        >
      </template>
    </CModal>
  </CFooter>
</template>

<script>
export default {
  name: "TheFooter",
  data() {
    return {
      privacyDialog: false,
    };
  },
};
</script>
